import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import ComponentsArrRenderer from './ComponentsArrRenderer';
import {
  useIsActive as useIsPagePreviewActive,
  useIfHideAppTop
} from '../../modules/page-preview';
import {
  useIsLayerTerminal,
  useIsActive
} from '../Others/layerControl/hooks';
import { useIsActiveByName, useSettingsByName } from '../../modules/hooks';
import { IconComp } from '../Layout';
import { JmeText } from '../typography';

const AppTop = (props) => {
  const { isActive: isAppTopActive, components } = useSelector((state) => state.appState?.settings?.appTop) ?? {};
  const navigate = useNavigate();
  // LayerControl
  const layerControlIsActive = useIsActive();
  const isLayerTerminal = useIsLayerTerminal();
  // Terminal
  const { appTopImage, startPage = '/', backButtonText } = useSettingsByName('terminal') ?? {};
  const isTerminalActive = useIsActiveByName('terminal');
  const isTerminalMode = Boolean(layerControlIsActive && isTerminalActive && isLayerTerminal);

  const isPagePreviewActive = useIsPagePreviewActive();
  const ifHideAppTop = useIfHideAppTop();
  const { pathname, search, hash } = window.location;
  const windowLocationRelative = `${pathname}${search}${hash}`;

  if (!isAppTopActive) return null;
  if (isPagePreviewActive && ifHideAppTop(windowLocationRelative)) return null;

  if (isTerminalMode) {
    // In terminal mode we should top image or hide the AppTop components
    if (!appTopImage) return null;
    return (
      <div className="app-top-terminal-mode">
        <img
          className="app-top-terminal-mode-image"
          src={appTopImage}
          alt="Terminal App Top"
          style={{ width: '100%', height: '250px', objectFit: 'cover' }}
        />
        {window.location.pathname !== startPage && (
          // Shows back button for all pages except of home page
          <button
            type="button"
            className="btn pl-0 jme-backButton-wrapper mb-3 terminal-back-button"
            aria-label="Back Button"
            onClick={() => navigate(startPage)}
          >
            <IconComp icon={{ name: 'chevron-left', iconType: 'fa' }} variant="mr-2" />
            <JmeText text={backButtonText} elemType="span" />
          </button>
        )}
      </div>
    );
  }

  return <ComponentsArrRenderer {...props} components={components} />;
};

export default AppTop;
